import { useEffect, useState } from 'react'
import './CGPADisplay.css'

function CGPADisplay({ currentCGPA }) {
  const [animatedCGPA, setAnimatedCGPA] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedCGPA(currentCGPA)
    }, 100)
    return () => clearTimeout(timer)
  }, [currentCGPA])

  const getGradeColor = (cgpa) => {
    if (cgpa >= 9) return '#28a745' // Green
    if (cgpa >= 8) return '#17a2b8' // Blue
    if (cgpa >= 7) return '#ffc107' // Yellow
    if (cgpa >= 6) return '#fd7e14' // Orange
    return '#dc3545' // Red
  }

  const getGradeText = (cgpa) => {
    if (cgpa >= 9) return 'Outstanding'
    if (cgpa >= 8) return 'Excellent'
    if (cgpa >= 7) return 'Very Good'
    if (cgpa >= 6) return 'Good'
    if (cgpa >= 5) return 'Average'
    return 'Below Average'
  }

  return (
    <div className="cgpa-display">
      <h3>Current CGPA</h3>
      <div 
        className="cgpa-value" 
        style={{ 
          color: getGradeColor(animatedCGPA),
          transform: animatedCGPA !== currentCGPA ? 'scale(1.1)' : 'scale(1)',
          transition: 'all 0.3s ease'
        }}
      >
        {animatedCGPA.toFixed(2)}
      </div>
      <div className="cgpa-grade" style={{ color: getGradeColor(animatedCGPA) }}>
        {getGradeText(animatedCGPA)}
      </div>
      <div className="cgpa-scale">
        Scale: 0.0 - 10.0
      </div>
    </div>
  )
}

export default CGPADisplay
